module.exports = {"TXTWCL_Something_went_wrong":{"id":"TXTWCL_Something_went_wrong","defaultMessage":"Något gick fel","track":"Something went wrong"}}